import { EditContentInDto, EditContentOutDto } from '../../../types/content.dto'

export const EDIT_CUSTOM_CONTENT_TYPE = 'EDIT_CUSTOM_CONTENT_TYPE'
export const EDIT_CUSTOM_CONTENT_TYPE_SUCCESS = 'EDIT_CUSTOM_CONTENT_TYPE_SUCCESS'
export const EDIT_CUSTOM_CONTENT_TYPE_ERROR = 'EDIT_CUSTOM_CONTENT_TYPE_ERROR'
export const RESET_EDIT_CUSTOM_CONTENT_TYPE = 'RESET_EDIT_CUSTOM_CONTENT_TYPE'

export interface EditCustomContentType {
  type: typeof EDIT_CUSTOM_CONTENT_TYPE
  payload: EditContentOutDto
}

export interface EditCustomContentTypeSuccess {
  type: typeof EDIT_CUSTOM_CONTENT_TYPE_SUCCESS
  payload: EditContentInDto
}

export interface EditCustomContentTypeError {
  type: typeof EDIT_CUSTOM_CONTENT_TYPE_ERROR
  payload: string | boolean
}

export interface ResetEditCustomContentType {
  type: typeof RESET_EDIT_CUSTOM_CONTENT_TYPE
  payload: null
}
export interface State {
  data: EditContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | EditCustomContentType
  | EditCustomContentTypeSuccess
  | EditCustomContentTypeError
  | ResetEditCustomContentType
